import * as React from 'react';
import VisuallyHidden from '../components/visuallyHidden';
export default function useIconLink(title, url) {
  var linkProps = {
    title: title,
    href: url
  };
  var iconProps = {
    'aria-hidden': true,
    focusable: false
  };
  var label = /*#__PURE__*/React.createElement(VisuallyHidden, null, title);
  return {
    linkProps: linkProps,
    iconProps: iconProps,
    label: label
  };
}